import { render, staticRenderFns } from "./ThresholdDetails.vue?vue&type=template&id=72e68435&scoped=true&"
import script from "./ThresholdDetails.vue?vue&type=script&lang=ts&"
export * from "./ThresholdDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ThresholdDetails.vue?vue&type=style&index=0&id=72e68435&lang=sass&scoped=true&"
import style1 from "./ThresholdDetails.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e68435",
  null
  
)

export default component.exports